import _ from "lodash";

const GROUPING_FIELD_LABELS = [
  { prefix: "likeForLike", label: "L4L" },
  { prefix: "likeForSimilar", label: "L4S option" },
  { prefix: "likeForUpgrade", label: "L4U option" },
];

const PLACEHOLDER_VALUES = ["null", "nil", "none", "n/a", "na", "-", "--"];

const EXISTING_VALUE_MARKER = "ExistingValue";
const TAG_FOR_MAPPING_FIELD = "likeForLike1";

const VIOLATION_PLACEHOLDER = "placeholder";
const VIOLATION_WHITE_SPACE = "white space";
const VIOLATION_UPPERCASE = "uppercase letters";

const MESSAGE_LINE_SEPARATOR = "\n";
const MESSAGE_BLOCK_SEPARATOR = "\n\n";

const isPlaceholder = (value) => PLACEHOLDER_VALUES.includes(value.toLowerCase());

const hasWhiteSpace = (value) => /\s/.test(value);

const hasUppercase = (value) => value !== value.toLowerCase();

const findGroupingFieldLabel = (fieldName) => {
  if (fieldName.includes(EXISTING_VALUE_MARKER)) {
    return null;
  }

  const groupingField = GROUPING_FIELD_LABELS.find((field) => fieldName.startsWith(field.prefix));
  if (!groupingField) {
    return null;
  }

  if (fieldName === TAG_FOR_MAPPING_FIELD) {
    return groupingField.label;
  }

  return `${groupingField.label}${fieldName.slice(groupingField.prefix.length)}`;
};

const trimToNull = (value) => {
  if (value == null) {
    return null;
  }

  const trimmedValue = String(value).trim();
  return trimmedValue === "" ? null : trimmedValue;
};

const findViolations = (value) => {
  const violations = [];

  if (isPlaceholder(value)) {
    violations.push(VIOLATION_PLACEHOLDER);
  }

  if (hasWhiteSpace(value)) {
    violations.push(VIOLATION_WHITE_SPACE);
  }

  if (hasUppercase(value)) {
    violations.push(VIOLATION_UPPERCASE);
  }

  return violations;
};

const formatViolationMessage = ({ sku, countryCode, carrierCode, fieldName, fieldLabel, value, violations }) => {
  const target = `SKU ${sku} (region ${countryCode}, partner ${carrierCode}) ${fieldLabel} is "${value}" (${violations.join(", ")}).`;
  const action = fieldName === TAG_FOR_MAPPING_FIELD
    ? "Please fix Tag for Mapping on the Article master. This value is not from the CSV."
    : "Please fix this value in the CSV and retry.";

  return [target, action].join(MESSAGE_LINE_SEPARATOR);
};

const forEachGroupingValue = (inputs, callback) => {
  Object.entries(inputs || {}).forEach(([sku, skuValue]) => {
    Object.entries(skuValue || {}).forEach(([countryCode, countryValue]) => {
      Object.entries(countryValue || {}).forEach(([carrierCode, carrierValue]) => {
        Object.entries(carrierValue || {}).forEach(([fieldName, fieldValue]) => {
          const fieldLabel = findGroupingFieldLabel(fieldName);
          if (!fieldLabel) {
            return;
          }

          callback({ sku, countryCode, carrierCode, carrierValue, fieldName, fieldLabel, fieldValue });
        });
      });
    });
  });
};

export const trimGroupingValues = (inputs) => {
  const trimmedInputs = _.cloneDeep(inputs || {});

  forEachGroupingValue(trimmedInputs, ({ carrierValue, fieldName, fieldValue }) => {
    carrierValue[fieldName] = trimToNull(fieldValue);
  });

  return trimmedInputs;
};

export const validateGroupingValues = (inputs) => {
  const violationMessages = [];

  forEachGroupingValue(inputs, ({ sku, countryCode, carrierCode, fieldName, fieldLabel, fieldValue }) => {
    const value = trimToNull(fieldValue);
    if (value == null) {
      return;
    }

    const violations = findViolations(value);
    if (!violations.length) {
      return;
    }

    violationMessages.push(
      formatViolationMessage({ sku, countryCode, carrierCode, fieldName, fieldLabel, value, violations })
    );
  });

  return [...new Set(violationMessages)];
};

export const formatGroupingValueErrors = (errors) => errors.join(MESSAGE_BLOCK_SEPARATOR);
